import * as React from 'react';
import styled from 'styled-components';
import { BREAKPOINTS } from '../styles';
import { Z_INDEXES } from '../styles';
import { MenuButton, MenuNavigationItemTypeItem } from '../GlobalNavigationBar';
import MobileMenuHeader from '../GlobalNavigationBar/mobile/MobileMenuHeader';
import MobileMenuContent from '../GlobalNavigationBar/mobile/MobileMenuContent';
import { MobileCustomMenuContent } from './MobileCustomMenuContent';

const Wrapper = styled.div`
  width: 320px;
  z-index: ${Z_INDEXES.off_canvas};
  height: 100%;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  gap: 8px;

  ${BREAKPOINTS.SMALL} {
    width: 400px;
  }
`;

interface Props {
  label: string;
  header: string;
  note?: string;
  onMenuClose: () => void;
  items?: MenuNavigationItemTypeItem[];
  footerAction?: MenuButton;
  customContent?: React.ReactNode;
}

const MobileSwitcherMenu = ({ label, header, note, onMenuClose, customContent, items, footerAction }: Props) => {
  return (
    <Wrapper role="menu" aria-labelledby="UserMenuButton">
      <MobileMenuHeader onGoBack={onMenuClose} label={label} onClose={onMenuClose} />
      {items && <MobileMenuContent header={{ header, note }} items={items} action={footerAction} />}
      {customContent && (
        <MobileCustomMenuContent header={{ header, note }} action={footerAction}>
          {customContent}
        </MobileCustomMenuContent>
      )}
    </Wrapper>
  );
};

export default MobileSwitcherMenu;
